import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { toAletheiaItem } from './aletheiaItemFallback'
import { type DniAnalysisTransformer } from './transformers'

export const viewItemTransformer: DniAnalysisTransformer = (platform, event) => {
  if (event.eventName !== 'view_item') return event
  const { currency = 'TWD', value = 0, items } = event.eventParams
  if (!items) return event
  const campaignCode = 'campaign_code' in event.eventParams ? event.eventParams.campaign_code : undefined
  if (platform === AnalyticsPlatforms.META_PIXEL) {
    return {
      eventName: 'ViewContent',
      eventParams: {
        content_ids: items.map(item => item.item_id).filter((id): id is string => id !== undefined),
        content_type: 'product',
        contents: items.map(item => ({
          id: item.item_id || 'None',
          quantity: item.quantity || 0,
        })),
        currency,
        value,
        campaign_code: campaignCode,
      },
    }
  }
  if (platform === AnalyticsPlatforms.ALETHEIA) {
    return {
      eventName: 'view_item',
      eventParams: {
        ...event.eventParams,
        items: event.eventParams.items?.map(item => toAletheiaItem(item, 'view_item')),
      },
    }
  }
  if (platform === AnalyticsPlatforms.OMNICHAT) {
    const products = items.map(item => ({
      id: item.item_id || '',
      quantity: item.quantity || 0,
      price: String(item.price || 0),
      brand: item.item_brand || '',
      name: item.item_name || '',
      variant: item.item_variant || '',
    }))
    return { eventName: 'view_product', eventParams: { items: products } }
  }
  if (platform === AnalyticsPlatforms.KLAVIYO) {
    /** Klaviyo Viewed Product 為單個產品，取首個產品 */
    const firstItem = items[0]

    return {
      eventName: 'Viewed Product',
      eventParams: {
        ProductName: firstItem?.item_name || undefined,
        ProductID: firstItem?.item_id || undefined,
        Brand: firstItem?.item_brand || undefined,
        Price: Number(firstItem?.price) || undefined,
      },
    }
  }
  return event
}
